import {defineMessages} from "@project/i18n";

export const serviceFieldLabelIds = {
  code: "fields.service.code",
  name: "fields.service.name",
  internalDescription: "fields.service.internalDescription",
  priceProtected: "fields.service.priceProtected",
  billingUnit: "fields.service.billingUnit",
  initialSupplierId: "fields.service.initialSupplierId",
} as const;

export const serviceFieldMessages = defineMessages({
  code: {
    id: "fields.service.code",
    defaultMessage: "Code",
    description: "Service field label for code",
  },
  name: {
    id: "fields.service.name",
    defaultMessage: "Name",
    description: "Service field label for name",
  },
  internalDescription: {
    id: "fields.service.internalDescription",
    defaultMessage: "Internal description",
    description: "Service field label for internal description",
  },
  priceProtected: {
    id: "fields.service.priceProtected",
    defaultMessage: "Price protected",
    description: "Service field label for price protection",
  },
  billingUnit: {
    id: "fields.service.billingUnit",
    defaultMessage: "Billing unit",
    description: "Service field label for billing unit",
  },
  initialSupplierId: {
    id: "fields.service.initialSupplierId",
    defaultMessage: "Initial supplier",
    description: "Service initial supplier field label",
  },
});

export const serviceValidationMessages = defineMessages({
  compositeRequired: {
    id: "validation.service.compositeRequired",
    defaultMessage: "A composite service cannot contain only one component with quantity one.",
    description: "Service create validation for the composite composition invariant",
  },
});
